export type FeatureFlags = Record<string, boolean>;

// Dispatched after the LaunchDarkly provider syncs flags into the runtime
// helper, so non-React sagas can react to flag availability/changes (the
// redux FEATURE_FLAGS_FETCH_SUCCESS action was removed with the old LD saga).
export const FEATURE_FLAGS_SYNCED = "featureFlags::synced";
export const featureFlagsSyncedAction = { type: FEATURE_FLAGS_SYNCED };

let currentFeatureFlags: FeatureFlags = {};

export function normalizeFeatureFlags(
  flags: Record<string, unknown> | undefined,
): FeatureFlags {
  const normalizedFlags: FeatureFlags = {};

  if (!flags) {
    return normalizedFlags;
  }

  for (const key in flags) {
    const value = flags[key];
    if (typeof value === "boolean") {
      normalizedFlags[key] = value;
    }
  }

  return normalizedFlags;
}

export function setFeatureFlags(flags: Record<string, unknown> | undefined) {
  currentFeatureFlags = normalizeFeatureFlags(flags);
}

export function getFeatureFlags() {
  return currentFeatureFlags;
}

export function __resetFeatureFlagsForTests() {
  currentFeatureFlags = {};
}
